// Sidebar.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ImageBox from '../shareable/imageBox';
import logo from '../../assets/images/image.png';
import { LogOut } from 'lucide-react';
import { navItems } from './items';
import SidebarNav from './sidebarNav';
import { useAuth } from '../../context/authContext';
import { useSidebar } from '../../context/CollapsedContext';

const Sidebar = () => {
  const location = useLocation();
  const { logout, user } = useAuth();
  const { collapsed, setCollapsed, isHovered, setIsHovered } = useSidebar();

  // Collapse sidebar by default if on /update/:id or /new-quote
  const shouldCollapse =
    location.pathname.startsWith('/update-quote/') ||
    location.pathname.startsWith('/new-quote');

  // Update collapse state when navigating
  useEffect(() => {
    setCollapsed(shouldCollapse);
  }, [location.pathname, setCollapsed, shouldCollapse]);

  // Determine if sidebar is currently expanded (either permanently or by hover)
  const isExpanded = !collapsed || isHovered;

  return (
    <div
      className={`bg-red-700 text-white p-3 min-h-screen flex flex-col justify-between item-center transition-all duration-300 ${
        collapsed && !isHovered ? 'w-16' : 'w-64'
      } relative cursor-pointer`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => { setIsHovered(false); setCollapsed(true); }}

    >
      <div>
        <a href='/'>
          <ImageBox
            src={logo}
            alt="Logo"
            width={collapsed && !isHovered ? 'w-10' : 'w-[150px]'}
            border={false}
            className={
              collapsed && !isHovered
                ? 'flex justify-center mx-auto mb-12'
                : 'flex justify-center mx-auto'
            }
          />
        </a>
        <div className='pl-2'>
          <SidebarNav navItems={navItems} collapsed={collapsed && !isHovered} user={user} />
        </div>
      </div>

      <div>
        {/* Always show logout button - with icon only when collapsed, icon + text when expanded */}
        <button
          onClick={() => logout()}
          className={`absolute bottom-4 p-1 flex items-center hover:bg-red-600 rounded transition-all duration-300 ${
            isExpanded ? 'left-4 gap-1' : 'left-1/2 transform -translate-x-1/2'
          }`}
        >
          <LogOut />
          {isExpanded && <strong>Logout</strong>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;

